import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutePathConstants, PageTitleConstants } from "../../Constants";
import { PageHeader, Loading, toastSuccessMessage } from "wup-module1-base";
import { Card } from "react-bootstrap";
import QuestionnaireForm from "./Form/QuestionnaireForm";
import { v4 as uuidv4 } from "uuid";

/**
 * Strona dodawania ankiety
 * @returns Komponent strony dodawania ankiety
 */
function QuestionnaireAdd() {
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [model, setModel] = useState({});
  const navigate = useNavigate();

  const onSubmit = (model) => {
    setIsSubmitting(true);
    //DO IMPLEMENTACJI
    // questionnaireservice.create(model)
    //   .then((res) => {
    //     toastSuccessMessage(res.data);
    //     navigate(`/${RoutePathConstants.Questionnaire}`);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsSubmitting(false);
    //   });

    updateSessionStorages("questionnaires", model);
    updateSessionStorages("pages", model.pages);
    updateSessionStorages("questions", model.questions);
    updateSessionStorages("answers", model.allAnswers);

    setIsSubmitting(false);
    toastSuccessMessage(`Pomyślnie dodano ankietę ${model.name}`);
    navigate(`/${RoutePathConstants.Questionnaire}`);
  };

  const updateSessionStorages = (itemKey, toUpdate) => {
    const currentSession = JSON.parse(sessionStorage.getItem(itemKey));
    console.log(currentSession);
    if (!!currentSession)
      sessionStorage.setItem(
        itemKey,
        JSON.stringify([
          ...currentSession,
          Array.isArray(toUpdate) ? [...toUpdate] : { ...toUpdate },
        ])
      );
    else
      sessionStorage.setItem(
        itemKey,
        JSON.stringify(Array.isArray(toUpdate) ? toUpdate : [{ ...toUpdate }])
      );
  };

  useEffect(() => {
    setIsLoading(true);
    const questionnaire = { id: uuidv4(), redirectNr: "1" };
    setModel(questionnaire);
    setIsLoading(false);
  }, []);

  return (
    <>
      <PageHeader content={PageTitleConstants.QuestionnaireAdd} />
      <Card>
        <Card.Body>
          {isLoading ? (
            <Loading />
          ) : (
            <QuestionnaireForm
              onSubmit={onSubmit}
              model={model}
              isSubmitting={isSubmitting}
            />
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default QuestionnaireAdd;
